// extracted by mini-css-extract-plugin
export default {"wrapper":"AllImplantsList_wrapper__SYWY5","category":"AllImplantsList_category__GGhmg","loading":"AllImplantsList_loading__xlb6y","selected":"AllImplantsList_selected__6DSyR"};